import { v1ApiClient } from '@/services';
import type {
  Operation,
  OperationRequestBody,
} from '@/shared/api/generated';

type MoveAggregatedReportsToFolderOperation =
  Operation<'MoveAggregatedReportsToFolder'>;

export type MoveAggregatedReportsToFolderParams =
  MoveAggregatedReportsToFolderOperation['parameters']['path'] &
    OperationRequestBody<'MoveAggregatedReportsToFolder'>;

export const moveAggregatedReportsToFolder = ({
  workspace_id,
  ...body
}: MoveAggregatedReportsToFolderParams) =>
  v1ApiClient
    .patch(`/workspaces/${workspace_id}/aggregated-reports/folder`, body)
    .then((res) => res.data);
